module.exports = __webpack_public_path__ + "static/media/logo-kanjiko.f1272337.png";